<template>
    <div id="content-editable-component" @click="closeList()">
        <hashtag-list
            ref="hashtagList"
            :show="showList"
            :top="top"
            :left="left"
            :hashtags="filteredList"
            :selectedIndex="selectedIndex"
            @click="e => addSnippetText(e, isMouseClicked)"
            @hover="e => (this.selectedIndex = e)"
        />

        <div
            v-if="isvhtml"
            :id="divId"
            :ref="divId"
            :contenteditable="!disabled"
            :class="{ 'div-disabled': disabled }"
            class="form-control pre-wrap"
            @input="debouncedInputHandler"
            @focus="focus"
            @blur="blur"
            v-html="valueText"
            @keyup.ctrl.delete="deleterow"
            :key="componentKey"
            :placeholder="placeholder"
        ></div>
        <!-- eslint-disable -->
        <!-- prettier-ignore-start -->
        <!-- The code here will be ignored by both ESLint and Prettier -->
        <!-- Unexplained Isssue: When applying formatting, when {{ value }} is not as below, it will cause a trailing space on text. Hence the comment. -->
        <!-- WARNING: PLEASE DONT CHANGE THE FORMATTING HERE, IF CHANGED, PLEASE REVERT IT BACK -->
        <div
            v-else
            :id="divId"
            :ref="divId"
            :contenteditable="!disabled"
            tabindex="0"
            :class="{ 'div-disabled': disabled }"
            class="form-control pre-wrap placeholder inline-block-scoped"
            @input="debouncedInputHandler"
            @focus="focus"
            @blur="blur"
            @keyup="triggerUpdateSocket"
            @cut="triggerUpdateSocket"
            :key="componentKey"
            :data-text="placeholder"
            :placeholder="placeholder"
        >{{ valueText }}</div>
        <!-- prettier-ignore-end -->
        <!-- eslint-enable -->
    </div>
</template>
<style type="text/css" lang="scss">
.pre-wrap {
    white-space: pre-wrap;
}
#editable-div p {
    margin-top: 0;
    margin-bottom: 5px;
}

/* Additional CSS for placeholder */
.placeholder:empty:before {
    content: attr(data-text) !important;
    color: #ccc;
    cursor: text;
}

/* Make sure the div is considered empty even when there's no text */
.placeholder:empty {
    outline: none;
}

.inline-block-scoped {
    display: inline-block;
}
</style>
<script type="text/javascript">
import {
    forEach,
    indexOf,
    clone,
    isNull,
    isEmpty,
    debounce,
    isUndefined
} from "lodash";
import hashtagList from "./hashtag-list.vue";
import Templates from "@/services/templates";
import { DateTime } from "luxon";

const CURSOR_MARKER_ID = "cursor-marker";
const IS_MOUSE_CLICKED = true;

export default {
    components: { hashtagList },
    props: {
        resizeHeight: {
            type: Boolean,
            default: false
        },
        defaultHeight: {
            type: Number, // in px
            default: null
        },
        divId: {
            type: String,
            default: "editable-div"
        },
        value: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        preventPreTag: {
            type: Boolean,
            default: false
        },
        isvhtml: {
            type: Boolean,
            default: true
        },
        isRelocateTextCursor: {
            type: Boolean,
            default: false
        },
        isDebounceInput: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focusIn: false,
            valueText: "",
            showList: false,
            top: 0,
            left: 0,
            list: [],
            hashtagsLoaded: false,
            selectedIndex: 0,
            typeStart: 0,
            componentKey: 0,
            eventValue: null,
            activeRange: null,
            isMouseClicked: IS_MOUSE_CLICKED,
            search: "",
            isLoadingList: false
        };
    },
    computed: {
        isSoap() {
            // by default this components is used in patient profile
            return this.$route.name === "soap";
        },
        localValue: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit("update:value", newValue);
            }
        },
        filteredList() {
            let newList = [];
            let self = this;

            self.selectedIndex = 0;

            if (this.search) {
                if (this.search.length > 1) {
                    let searchText = this.search.slice(1, this.search.length);

                    forEach(this.list, function (snippet) {
                        let text = snippet.hashtag.replace(/^#+/, ""); // trailing hashtag will be ignored, focus on text itself
                        if (
                            text.indexOf(searchText) !== -1 &&
                            text.startsWith(searchText)
                        ) {
                            newList.push(snippet);
                        }
                    });

                    return newList;
                }
            }

            return this.list;
        },
        cursorMarkerHTML() {
            return `<span id="${CURSOR_MARKER_ID}" style="display:none"></span>`;
        }
    },
    watch: {
        localValue(newVal) {
            if (!this.focusIn) {
                this.valueText = newVal;
            }
        },
        filteredList(newVal) {
            if (newVal.length == 0 && !this.isLoadingList) {
                this.showList = false;
            }
        }
    },
    created() {
        if (this.isDebounceInput) {
            this.debouncedInputHandler = debounce(this.update, 500);
        } else {
            this.debouncedInputHandler = this.update;
        }
    },
    mounted() {
        this.valueText = this.value;

        this.addListener();
        this.setEditableHeight();
    },
    methods: {
        triggerUpdateSocket(e) {
            let self = this;
            if (self.isSoap) {
                // currently only used by soap
                const value = e.target.innerText;

                if (!isUndefined(value)) {
                    // Fire socket update to make sure other user get the latest editted input
                    self.$emit("socket-update", self.divId, value);
                }
            }
        },
        addListener() {
            var self = this;

            const editableDiv = document.getElementById(self.divId);

            editableDiv.addEventListener("keydown", e => {
                self.triggerSnippet(e);
                self.replaceKeywordSnippet(e);
            });

            if (!this.isvhtml) {
                editableDiv.addEventListener("copy", e => {
                    const selection = document.getSelection();
                    e.clipboardData.setData("text/plain", selection);
                    e.preventDefault();
                });
            }

            editableDiv.addEventListener("paste", async e => {
                self.triggerUpdateSocket(e);

                let clipboardData = e.clipboardData || window.clipboardData;
                let keyPaste = clipboardData.getData("Text");
                const isKeyPasteStartWithHashtag =
                    keyPaste.length && /^#\S+$/.test(keyPaste);

                if (!self.isvhtml) {
                    e.preventDefault();
                    this.insertPasteText(keyPaste);
                }

                if (keyPaste === "#") {
                    // Render the snippet API and populate the list
                    self.triggerSnippet(e, keyPaste);
                } else if (keyPaste.length > 1 && isKeyPasteStartWithHashtag) {
                    // Render the snippet API,populate the list and filter the snippet
                    await self.triggerSnippet(e, "#");
                    self.triggerSnippet(e, keyPaste.substring(1));
                }
            });
        },
        triggerSnippet(e, keyPaste = null) {
            let self = this;

            const isKeyPreventDefault = indexOf([38, 40, 13], e.keyCode) != -1;
            if (self.showList && isKeyPreventDefault) {
                e.preventDefault();
            }

            // SetTimeout with a delay of 0 is a common technique to defer code execution slightly, allowing the browser to complete its current tasks before executing the delayed code.
            setTimeout(async () => {
                let key = e.key;
                if (e.type === "paste") {
                    key = keyPaste;
                }

                var selection = window.getSelection();

                self.eventValue = e;
                if (key === "#") {
                    // Trigger API to get the list of snippets
                    self.search = "#";

                    // VET-3401 - Enhancement for the snippet flow where, key-in "#" will populate the snippet dropdown
                    await self.getList();

                    self.showList = true;
                    setFields(true);
                } else {
                    if (self.showList) {
                        switch (e.keyCode) {
                            case 9: // Tab key
                                self.closeList();
                                return null;

                            case 8: // Delete key
                                if (self.search.length == 1) {
                                    self.closeList();
                                    return null;
                                } else {
                                    self.search = self.search.slice(
                                        0,
                                        self.search.length - 1
                                    );
                                }
                                break;

                            case 13: // Enter key
                                self.addSnippetText(
                                    self.selectedIndex,
                                    !IS_MOUSE_CLICKED
                                );
                                return true;

                            case 38: // Arrow Up
                                if (self.selectedIndex == 0) {
                                    self.selectedIndex =
                                        this.filteredList.length - 1;
                                } else {
                                    self.selectedIndex--;
                                }
                                break;

                            case 40: // Arrow Down
                                if (
                                    self.selectedIndex ==
                                    self.filteredList.length - 1
                                ) {
                                    self.selectedIndex = 0;
                                } else {
                                    self.selectedIndex++;
                                }
                                break;
                            case 16: // shift
                            case 20: // capslock
                                // Skip as Shift for Capital letter
                                // Skip as Caps Lock for Capital Letter
                                return;
                            default:
                                // For any other key, append to `self.search` if not prevented
                                if (!isKeyPreventDefault) {
                                    self.search += key;
                                }
                        }
                        setFields(false);
                    } else {
                        // TODO: Need to handle scenario when user click outside, the list showList = false, then when user continue key-in after the search, the snippet should shown with the filtered search
                        if (self.search && self.search != "") {
                            if (self.search === "#") {
                                if (e.keyCode === 8) {
                                    // delete key
                                    self.closeList();
                                    return null;
                                } else {
                                    self.search += key;
                                }

                                self.showList = true;
                                if (selection.rangeCount !== 0) {
                                    setFields(true);
                                }
                            } else if (self.search.charAt(0) == "#") {
                                if (e.keyCode === 8) {
                                    // delete key
                                    self.search = self.search.slice(
                                        0,
                                        self.search.length - 1
                                    );
                                } else {
                                    self.search += key;
                                }

                                if (self.filteredList.length > 0) {
                                    self.showList = true;
                                    setFields(false);
                                }
                            }
                        }
                    }
                }

                function setFields(isStart) {
                    self.activeRange = selection.getRangeAt(0);

                    if (isStart) {
                        self.typeStart = self.activeRange.startOffset;
                    } else {
                        self.typeStart =
                            self.activeRange.startOffset - self.search.length;
                    }

                    const startRange = self.activeRange.cloneRange(); // Create a copy of the original range
                    // For start position
                    startRange.collapse(true);
                    const startRect = startRange.getClientRects()[0];
                    if (startRect) {
                        // Adjust by parent's position
                        const parentPos = self.getPositionRelativeToParent();

                        self.left = startRect.left - parentPos.x;
                        self.top = startRect.top - parentPos.y;
                    }
                }
            }, 0);
        },
        getPositionRelativeToParent() {
            const element = document.getElementById(this.divId);
            const rect = element.getBoundingClientRect(); // Element's position relative to the viewport

            return { x: rect.left, y: rect.top };
        },
        closeList() {
            this.showList = false;
            this.search = null;
        },
        clickToAddSnippet(snippetIndex) {
            this.addSnippetText(snippetIndex, IS_MOUSE_CLICKED);
        },
        addSnippetText(snippetIndex, isMouseClicked) {
            let data = "";
            const CURSOR_MARKER_STRING = `CURSOR_MARKER_HERE_${this.uniqid()}`;
            if (
                this.activeRange.commonAncestorContainer.nodeType ===
                Node.TEXT_NODE
            ) {
                data = clone(this.activeRange.commonAncestorContainer.data);
            }

            // Add space at the end of the new text
            let newText = `${this.filteredList[snippetIndex].elements} `;
            let startText = data.substring(0, this.typeStart);
            let endText = data.substring(this.typeStart);
            // Create a DOM fragment to hold the new HTML
            let fragment = document.createDocumentFragment();

            // Create a temp container to set innerHTML
            let tempDiv = document.createElement("div");
            // To place the text cursor after add snippet

            // If search with text, there is issue that the search still in the endText #keyword
            if (endText.startsWith(this.search)) {
                endText = endText.replace(this.search, "");
            }

            // If search only with #, issue where the # not been replaced by the content of snippet but it still placed before the snippet content
            if (this.search === "#" && startText.endsWith("#")) {
                startText = startText.slice(0, -this.search.length);
            }

            let cursorMarker = "";
            if (this.isvhtml) {
                cursorMarker = this.cursorMarkerHTML;
                tempDiv.innerHTML =
                    startText + newText + cursorMarker + endText;
            } else {
                cursorMarker = CURSOR_MARKER_STRING;
                // For soap or not use isvhtml will maintain the snippet to view as a text
                tempDiv.textContent =
                    startText + newText + cursorMarker + endText;
            }

            // Append child nodes of the temporary DIV to the fragment
            while (tempDiv.firstChild) {
                fragment.appendChild(tempDiv.firstChild);
            }

            // Clear the original text to prepare for new content
            var textNode = this.activeRange.commonAncestorContainer;
            if (
                this.activeRange.commonAncestorContainer.nodeType ===
                Node.TEXT_NODE
            ) {
                textNode.data = "";
            }

            // Replace the range content with the new fragment
            this.activeRange.insertNode(fragment);

            this.setCursorAfterMarker(
                CURSOR_MARKER_ID,
                cursorMarker,
                CURSOR_MARKER_STRING,
                isMouseClicked
            );
            this.update(this.eventValue);

            this.closeList();
        },
        noteIterator(element) {
            return document.createNodeIterator(
                element,
                NodeFilter.SHOW_TEXT // Only consider text nodes
            );
        },
        setCursorAfterMarker(
            markerId,
            cursorMarker,
            CURSOR_MARKER_STRING,
            isMouseClicked
        ) {
            let elDiv = document.getElementById(this.divId);
            if (cursorMarker === CURSOR_MARKER_STRING) {
                elDiv.innerHTML = elDiv.innerHTML.replace(
                    cursorMarker,
                    this.cursorMarkerHTML
                );
            }

            const marker = document.getElementById(markerId);
            if (marker) {
                if (isMouseClicked) {
                    // focus to the div
                    elDiv.focus({ preventScroll: true });
                }

                const range = document.createRange();
                const sel = window.getSelection();
                range.setStartAfter(marker);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);

                // Remove the marker after placing the cursor
                marker.parentNode.removeChild(marker);
            }
        },
        processText(text) {
            //highlight alphabet matched
            return text;
        },
        getList() {
            if (this.hashtagsLoaded) {
                return true;
            }
            this.isLoadingList = true;
            this.selectedIndex = 0;
            Templates.getAllSnippet()
                .then(response => {
                    this.list = response.resource.data;
                    this.hashtagsLoaded = true;
                })
                .finally(() => {
                    this.isLoadingList = false;
                });
        },
        deleterow() {
            // this.$emit('delete-row');
        },
        update(e) {
            this.localValue = this.preventPreTag
                ? this.handlePreTag(e.target.innerHTML)
                : e.target.innerHTML;

            if (this.resizeHeight) {
                this.setEditableHeight();
            }
            this.$emit(
                "update",
                this.divId,
                this.preventPreTag
                    ? this.handlePreTag(e.target.innerHTML)
                    : e.target.innerHTML
            );
        },
        setEditableHeight() {
            if (isNull(this.defaultHeight)) {
                return "";
            }

            // Cannot use this.localValue/this.valueText as in this function, the value not updated
            this.$nextTick(() => {
                this.$refs[this.divId].style.height = "auto"; // to make the editable set height followed the inner elements and then below will set height default or auto
                let height = `${this.defaultHeight}px`;
                if (this.$refs[this.divId]) {
                    let { clientHeight, innerHTML } = this.$refs[this.divId];
                    if (
                        !isEmpty(innerHTML) &&
                        clientHeight >= this.defaultHeight
                    ) {
                        height = "auto";
                    }
                }
                this.$refs[this.divId].style.height = height;
            });
        },
        focus() {
            if (this.isRelocateTextCursor) {
                this.relocateTextCursor();
            }
            this.$emit("focus");
            this.focusIn = true;
        },
        blur(e) {
            const isRelatedToHashtagDiv = this.$refs.hashtagList?.$refs[
                "hashtag-list"
            ]?.contains(e.relatedTarget);

            if (!isRelatedToHashtagDiv) {
                this.$emit("blur");
                this.showList = false;
                this.focusIn = false;
            }
        },
        handlePreTag(str) {
            // Issue VET-2619: https://daysmartsoftware.atlassian.net/browse/VET-2619
            // for a rare case where user copied a text that contain <pre></pre> it will messep up the PDF rendering as the pre tag will preserve spaces and line breaks.
            // Using a regular expression to extract the text content.
            return str.replace(/<\/?pre[^>]*>/g, "");
        },
        relocateTextCursor() {
            // fixing issue where the text cursor is located at the beginning of the text instead of at the end after re-focused in soap.
            const el = this.$refs[this.divId];
            const range = document.createRange();
            const sel = window.getSelection();
            range.selectNodeContents(el);
            range.collapse(false); // false collapses the range to the end
            sel.removeAllRanges(); // Remove all ranges from selection
            sel.addRange(range);
            el.focus(); // Ensure the div is focused
        },
        insertPasteText(text) {
            const el = this.$refs[this.divId];
            const sel = window.getSelection();
            const range = sel.getRangeAt(0);

            // store current cursor position
            const startOffset = range.startOffset;

            // delete selected content
            range.deleteContents();

            // Create a text node with the provided text
            const textNode = document.createTextNode(text);

            // find the insertion cursor position
            if (range.startContainer.nodeType === Node.TEXT_NODE) {
                // if the start container is a text node
                if (startOffset === range.startContainer.length) {
                    // if the cursor is at the end of the text node
                    range.startContainer.parentNode.insertBefore(
                        textNode,
                        range.startContainer.nextSibling
                    );
                } else {
                    // If the cursor is in the middle of the text node
                    range.startContainer.splitText(startOffset);
                    range.startContainer.parentNode.insertBefore(
                        textNode,
                        range.startContainer.nextSibling
                    );
                }
            } else {
                // if the start container is an element node
                if (
                    range.startContainer.childNodes.length === 0 ||
                    startOffset === range.startContainer.childNodes.length
                ) {
                    // if there are no children or the cursor is at the end of the element
                    range.startContainer.appendChild(textNode);
                } else {
                    // if the cursor is in the middle of the element's children
                    range.startContainer.insertBefore(
                        textNode,
                        range.startContainer.childNodes[startOffset]
                    );
                }
            }

            // Update the selection with the new range
            range.setStart(textNode, text.length);
            range.setEnd(textNode, text.length);
            sel.removeAllRanges();
            sel.addRange(range);

            // trigger the update event manually
            el.dispatchEvent(new Event("input", { bubbles: true }));

            el.focus();
        },
        replaceKeywordSnippet(e) {
            // trigger on letter "e" as in the last char in "#date" & "#time"
            if (e.key === "e") {
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                let container = range.commonAncestorContainer;

                // If the container is not a text node, find the appropriate text node
                if (container.nodeType !== Node.TEXT_NODE) {
                    if (container.childNodes.length > 0) {
                        container = container.childNodes[range.startOffset];
                    }
                }

                if (container && container.nodeType === Node.TEXT_NODE) {
                    const text = container.textContent;

                    // Check if the text contains "#date" or "#time"
                    const dateShortcutIndex = text.lastIndexOf("#dat");
                    const timeShortcutIndex = text.lastIndexOf("#tim");

                    if (dateShortcutIndex !== -1 || timeShortcutIndex !== -1) {
                        // Prevent default behavior of inserting "e"
                        e.preventDefault();

                        let newText = "";
                        let shortcutIndex = -1;

                        const timezone =
                            this.$root?.setting?.timezone ?? this._timeZone;

                        // if the text contains "#date"
                        if (dateShortcutIndex !== -1) {
                            shortcutIndex = dateShortcutIndex;

                            const formatString =
                                this._getLuxonFormat() + " hh:mm:ss a";
                            const timestamp = DateTime.now()
                                .setZone(timezone)
                                .toFormat(formatString);

                            let initials =
                                localStorage.getItem("my_staff_initials") || "";
                            if (initials !== "") {
                                initials = ` (${initials})`;
                            }

                            newText = `${timestamp}${initials}`;
                        }

                        // if the text contains "#time"
                        else if (timeShortcutIndex !== -1) {
                            shortcutIndex = timeShortcutIndex;
                            newText = DateTime.now()
                                .setZone(timezone)
                                .toFormat("hh:mm a");
                        }

                        const beforeText = text.substring(0, shortcutIndex);
                        const afterText = text.substring(shortcutIndex + 4);

                        // Create a document fragment to handle replacement without losing line breaks
                        const fragment = document.createDocumentFragment();

                        // Append before text
                        if (beforeText) {
                            fragment.appendChild(
                                document.createTextNode(beforeText)
                            );
                        }

                        // Create a new text node for the current date
                        const dateNode = document.createTextNode(newText);
                        fragment.appendChild(dateNode);

                        // Append after text
                        if (afterText) {
                            fragment.appendChild(
                                document.createTextNode(afterText)
                            );
                        }

                        // Replace the current container content with the new fragment
                        container.replaceWith(fragment);

                        // Set the cursor after the inserted date node
                        const newRange = document.createRange();
                        newRange.setStartAfter(dateNode);
                        newRange.collapse(true);

                        selection.removeAllRanges();
                        selection.addRange(newRange);

                        // trigger the update event manually
                        const inputEvent = new Event('input', { bubbles: true });
                        this.$refs[this.divId].dispatchEvent(inputEvent);
                    }
                }
            }
        }
    }
};
</script>
